import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core'
import Loader from '../../elements/Loader'
import InputField from '../../elements/InputField'
import { requiredFieldValidation } from '../../utils/validation'
import DatePicker from '../../elements/DatePicker'
import { Button } from '@material-ui/core';
import Select from '../../elements/Select';

const UpdateLessonsPage = (props) => {
  const { groups, currentUser, isLoading, fetchGroups, fetchSaveLessons, isLessonSaved, lessonId, lessonById, fetchLessonsById, patchLessonById } = props
  const [date, setDate] = useState({ value: null, error: '' });
  const [group, setGroup] = useState({ value: '', error: '' });
  const [title, setTitle] = useState({ value: '', error: '' });
  const [shortTitle, setShortTitle] = useState({ value: '', error: '' });
  const [slides, setSlides] = useState({ value: '', error: '' });
  const [video, setVideo] = useState({ value: '', error: '' });
  const [reading, setReading] = useState({ value: '', error: '' });
  const [homework, setHomework] = useState({ value: '', error: '' });
  const [workshop, setWorkshop] = useState({ value: '', error: '' });
  const [optionsGroup, setOptionsGroup] = useState([]);

  const isAdd = !lessonId;

  useEffect(() => {
    setDate({ value: null, error: '' });
    setGroup({ value: '', error: '' });
    setTitle({ value: '', error: '' });
    setShortTitle({ value: '', error: '' });
    setSlides({ value: '', error: '' });
    setVideo({ value: '', error: '' });
    setReading({ value: '', error: '' });
    setHomework({ value: '', error: '' });
    setWorkshop({ value: '', error: '' });
    if (lessonId) {
      fetchLessonsById(lessonId);
    }
    // eslint-disable-next-line
  }, [lessonId])

  useEffect(() => {
    if (Object.keys(lessonById).length > 0) {
      setDate({ value: lessonById.date })
      setGroup({ value: lessonById.group });
      setTitle({ value: lessonById.title });
      setShortTitle({ value: lessonById.shortTitle });
      setSlides({ value: lessonById.slides });
      setVideo({ value: lessonById.video });
      setReading({ value: lessonById.reading });
      setHomework({ value: lessonById.homework });
      setWorkshop({ value: lessonById.workshop });
    } else {
      setDate({ value: null, error: '' });
      setGroup({ value: '', error: '' });
      setTitle({ value: '', error: '' });
      setShortTitle({ value: '', error: '' });
      setSlides({ value: '', error: '' });
      setVideo({ value: '', error: '' });
      setReading({ value: '', error: '' });
      setHomework({ value: '', error: '' });
      setWorkshop({ value: '', error: '' });
    }
  }, [lessonById])

  useEffect(() => {
    if (currentUser && currentUser.optional) {
      if (currentUser.optional.role === 'teacher') {
        const opts = currentUser.optional.groups ? currentUser.optional.groups.map(el => ({ value: el, label: el })) : [];
        setOptionsGroup(opts);
      } else if (currentUser.optional.role === 'admin') {
        fetchGroups();
      }
    }
    // eslint-disable-next-line 
  }, [currentUser])

  useEffect(() => {
    if (groups.length > 0) {
      const opts = groups.map(el => ({ value: el, label: el }));
      setOptionsGroup(opts);
    }
  }, [groups])

  useEffect(() => {
    if (isLessonSaved && isAdd) {
      setDate({ value: null, error: '' });
      setGroup({ value: '', error: '' });
      setTitle({ value: '', error: '' });
      setShortTitle({ value: '', error: '' });
      setSlides({ value: '', error: '' });
      setVideo({ value: '', error: '' });
      setReading({ value: '', error: '' });
      setHomework({ value: '', error: '' });
      setWorkshop({ value: '', error: '' });
    }
    // eslint-disable-next-line
  }, [isLessonSaved])

  const handleDate = (dateField, value) => {
    if (!value) {
      setDate({ value: value, error: 'Date is required' })
    } else if (dateField === 'Invalid Date') {
      setDate({ value: value, error: 'Invalid Date' })
    } else {
      setDate({ value: value, error: '' })
    }
  }

  const handleGroup = (value) => {
    if (requiredFieldValidation(value, 'Group')) {
      setGroup({ value: value, error: requiredFieldValidation(value, 'Group') })
    } else {
      setGroup({ value: value })
    }
  }
  const handleTitle = (value) => {
    if (requiredFieldValidation(value, 'Title')) {
      setTitle({ value: value, error: requiredFieldValidation(value, 'Title') })
    } else {
      setTitle({ value: value })
    }
  }
  const handleShortTitle = (value) => {
    if (requiredFieldValidation(value, 'Short title')) {
      setShortTitle({ value: value, error: requiredFieldValidation(value, 'Short title') })
    } else {
      setShortTitle({ value: value })
    }
  }
  const handleVideo = (value) => {
    if (requiredFieldValidation(value, 'Video')) {
      setVideo({ value: value, error: requiredFieldValidation(value, 'Video') })
    } else {
      setVideo({ value: value })
    }
  }

  const submitHandle = () => {
    let noErrors = true;
    let pageFields = {};
    if (requiredFieldValidation(date.value, 'Date')) {
      noErrors = false;
      setDate({ ...date, error: requiredFieldValidation(date.value, 'Date') })
    } else if (date.error) {
      noErrors = false;
    }
    if (requiredFieldValidation(group.value, 'Group')) {
      noErrors = false;
      setGroup({ ...group, error: requiredFieldValidation(group.value, 'Group') })
    }
    if (requiredFieldValidation(title.value, 'Title')) {
      noErrors = false;
      setTitle({ ...title, error: requiredFieldValidation(title.value, 'Title') })
    }
    if (requiredFieldValidation(shortTitle.value, 'Short title')) {
      noErrors = false;
      setShortTitle({ ...shortTitle, error: requiredFieldValidation(shortTitle.value, 'Short title') })
    }
    if (requiredFieldValidation(video.value, 'Video')) {
      noErrors = false;
      setVideo({ ...video, error: requiredFieldValidation(video.value, 'Video') })
    }
    if (noErrors) {
      if (!isAdd) {
        pageFields.id = lessonId;
      }
      pageFields.date = date.value;
      pageFields.group = group.value;
      pageFields.title = title.value;
      pageFields.shortTitle = shortTitle.value;
      pageFields.slides = slides.value;
      pageFields.video = video.value;
      pageFields.reading = reading.value;
      pageFields.homework = homework.value;
      pageFields.workshop = workshop.value;
      if (isAdd) {
        fetchSaveLessons(pageFields);
      } else patchLessonById(pageFields)
    } else {
      console.log('errors')
    }
  }

  return (<div>
    {isLoading && <Loader />}
    <div className='text-center'>
      <Container maxWidth='md' style={{ padding: '24px' }}>
        <h1>Add Lesson</h1>
        <DatePicker
          disableToolbar={true}
          required={true}
          format="MM/dd/yyyy"
          margin="normal"
          id="date"
          label="Date"
          error={date.error}
          value={date.value} onChange={(dateField, value) => handleDate(dateField, value)}
        />

        <Select
          label='Group'
          value={group.value}
          onChange={(e) => handleGroup(e.target.value)} options={optionsGroup}
          required={true}
          error={group.error}
        />

        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => handleTitle(e.target.value)
          }
          required={true}
          label='Title'
          value={title.value}
          error={title.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => handleShortTitle(e.target.value)
          }
          required={true}
          label='Short title'
          value={shortTitle.value}
          error={shortTitle.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => setSlides({ value: e.target.value, error: '' })
          }
          label='Slides'
          value={slides.value}
          error={slides.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => handleVideo(e.target.value)
          }
          required={true}
          label='Video'
          value={video.value}
          error={video.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => setReading({ value: e.target.value, error: '' })
          }
          label='Reading'
          value={reading.value}
          error={reading.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => setHomework({ value: e.target.value, error: '' })
          }
          label='Homework'
          value={homework.value}
          error={homework.error}
        />
        <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
          onChange={
            (e) => setWorkshop({ value: e.target.value, error: '' })
          }
          label='Workshop'
          value={workshop.value}
          error={workshop.error}
        />

        <div style={{ display: 'flex', direction: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
          <Button color='primary' variant='contained' onClick={() => props.history.goBack()}>Cancel</Button>
          <Button color='primary' variant='contained' onClick={submitHandle}>Save</Button>
        </div>
        {isLessonSaved ?
          <div style={{ color: 'green' }} className=" ml-3 ">Lesson saved</div>
          :
          <div style={{ color: 'red' }} className=" ml-3 ">{props.error}</div>

        }
      </Container>
    </div>
  </div>)
}

export default UpdateLessonsPage